import {LoadingSpinner} from './loading-spinner/loading'
import * as styled from './data-loading.styled'
export const DataLoading = (): JSX.Element => (
    <styled.DataLoading>
        <LoadingSpinner size={100} />
    </styled.DataLoading>
)
